import { render, staticRenderFns } from "./TaskFilterComponent.vue?vue&type=template&id=a46dc2e4&scoped=true"
import script from "./TaskFilterComponent.vue?vue&type=script&lang=js"
export * from "./TaskFilterComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskFilterComponent.vue?vue&type=style&index=0&id=a46dc2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46dc2e4",
  null
  
)

export default component.exports